import { z } from 'zod';
export const DeleteTemplateApiSchema = {
    params: z.object({
        id: z.string(),
    }),
    headers: z.object({
        requestActor: z.string().optional(),
    }),
};
export const DeleteTemplateRequestSchema = DeleteTemplateApiSchema.params.merge(DeleteTemplateApiSchema.headers);
